import Backend from 'backend';
import {inject} from 'aurelia-framework';

@inject(Backend)
export class BrodReport2Screen {
  backend;

  // For dropdowns
  reportingPeriods;

  // Query
  selectedReportingPeriod;

  // Query result
  report;

  constructor(backend) {
    this.backend = backend;
  }

  activate() {
    return this.refresh();
  }

  refresh() {
    Promise.all([
      this.backend.ReportingPeriodsForDropdownQueryHandler_handle()
        .then(result => this.reportingPeriods = result.reportingPeriods),
    ]);
  }

  query() {
    return this.backend.BrodReport2QueryHandler_handle({
      yearMonth: this.selectedReportingPeriod
    })
      .then(result => this.report = result);
  }
}
